<script setup>
defineProps({
    value: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <figure class="mt-16">
        <img
            class="rounded-xl bg-gray-50 object-cover"
            :src="'/storage/' + value.url"
            :alt="value?.alt ?? value.url"
        />
        <figcaption>
            {{ value?.alt }}
        </figcaption>
    </figure>
</template>
